export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '课程名称',
    field: 'programName',
  },
  {
    headerName: '课程编码',
    field: 'scoId',
  },
  {
    headerName: '课程分类',
    field: 'programCategoryName',
  },
  {
    headerName: '归属部门',
    field: 'programSource',
  },
  {
    headerName: '课程状态',
    field: 'status',
  },
  {
    headerName: '学员账号',
    field: 'account',
  },
  {
    headerName: '学员姓名',
    field: 'fullName',
  },
  // {
  //   headerName: '学员身份证',
  //   field: 'idCard',
  // },
  {
    headerName: '账号状态',
    field: 'accountState',
  },
  {
    headerName: '组织名称',
    field: 'orgName',
  },
  {
    headerName: '组织编码',
    field: 'orgCode',
  },
  {
    headerName: '组织类型',
    field: 'orgTypeName',
  },
  {
    headerName: '省份',
    field: 'province'
  },
  {
    headerName: '上级组织',
    field: 'leadName',
  },
  {
    headerName: '岗位',
    field: 'positionName',
  },
  {
    headerName: '任职状态',
    field: 'jobState',
  },
  {
    headerName: '课程完成率',
    field: 'finishRate',
  },
  {
    headerName: '通过状态',
    field: 'passName',
  },
  {
    headerName: '开始学习时间',
    field: 'firstTime',
  },
  {
    headerName: '末次学习时间',
    field: 'lastTime',
  },
  {
    headerName: '课程通过时间',
    field: 'passDate',
  },
  {
    headerName: '学习时长',
    field: 'duration',
  }, 
]
